import request from '@/utils/request'

// 登录
export function login(data) {
  return request({ url: '/api/auth/login', method: 'post', data })
}

// 退出登录
export function logout() {
  return request({ url: '/api/auth/logout', method: 'post' })
}

// 重置密码
export function resetPassword(data) {
  return request({ url: '/api/auth/resetPassword', method: 'put', data })
}

// 获取当前用户菜单树
export function getUserMenus() {
  return request({ url: '/api/auth/menus', method: 'get' })
}

// 获取当前用户权限标识列表（按钮权限）
export function getUserPerms() {
  return request({ url: '/api/auth/perms', method: 'get' })
}
